import { Box, Button, Typography } from "@material-ui/core"
import FormInput from "components/Reusable/FormsComp/FormInput"
import { useFormikContext } from "formik"
import styled from "styled-components"

const StyledButton = styled(Button)`
  width: 50px;
  height: 50px;
  color: #757575;

  min-width: 50px;
  font-size: 26px;
  font-family: "NarkisBlock-Thin", san-serif;
  font-weight: 100;

  border-radius: 8px;
  border: 1px solid #e5e5e5;
  background: var(--White, #fff);

  :hover {
    background: var(--White, #fff);
    border: 2px solid var(--Grey, #757575);
  }
`

const StyledBoxWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`

const StyledValueBox = styled(Box)<{ $quantity: number }>`
  width: 50px;
  height: 50px;
  color: #757575;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;

  input {
    font-family: ${(p) => (p.$quantity > 0 ? "NarkisBlock" : "inherit")};
    font-weight: ${(p) => (p.$quantity > 0 ? "bold" : "normal")};
    font-size: 26px;
    text-align: center;
    padding-left: 0px;
    padding-right: 0px;
    background: var(--White, #fff);
    &:disabled {
      color: ${(p) => (p.$quantity > 0 ? "#264f36 !important" : "#757575")};
      -webkit-text-fill-color: ${(p) =>
        p.$quantity > 0 ? "#264f36" : "#757575"};
    }
  }

  .MuiOutlinedInput-input {
    color: ${(p) => (p.$quantity > 0 ? "#264f36 !important" : "#757575")};
  }

  fieldset {
    border: none;
    border-radius: 8px;
    border: 1px #e5e5e5 solid;
  }

  div {
    margin-top: 0px;
  }

  .MuiFormControl-root {
    width: 50px;
    height: 50px;
  }

  #quantity-helper-text {
    width: 300px;
    margin-right: -55px !important;
  }
  .MuiOutlinedInput-root {
    box-shadow: none;
  }
  fieldset {
    width: 50px;
    height: 50px;
    top: 0;
  }
`

const StyledWrapper = styled(Box)`
  height: 76px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 0px;
  }
  p {
    color: #000;
  }
`
const StyledError = styled(Typography).attrs({ variant: "body1" })`
  color: #d70202 !important;
  line-height: 1.1;
  text-align: right;
  margin-top: 4px;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  font-size: 18px;
  text-align: right;
`

type QuantityBoxProps = {
  quantityError: boolean
  setQuantityError: React.Dispatch<React.SetStateAction<boolean>>
  setAmountError: React.Dispatch<React.SetStateAction<string>>
  setQuantity: React.Dispatch<React.SetStateAction<number>>
  quantity: number
  maxGiftCard: number
  maxAmuont: number
  minAmount: number
}

const QuantityBox = ({
  quantityError,
  setQuantityError,
  setAmountError,
  quantity,
  setQuantity,
  maxGiftCard,
  maxAmuont,
  minAmount,
}: QuantityBoxProps) => {
  const formikProps = useFormikContext<any>()

  const checkAmountValidation = (number: number) => {
    if (number * formikProps.values.amount > maxAmuont)
      setAmountError(`ניתן להכניס סכום מקסימלי של עד ${maxAmuont} ש״ח`)
    else if (number * formikProps.values.amount < minAmount)
      setAmountError(`ניתן להכניס סכום מינימלי של לפחות ${minAmount} ש״ח`)
    else setAmountError("")
  }

  const incrementCounter = () => {
    if (quantity < maxGiftCard) {
      setQuantity(quantity + 1)
      formikProps.setFieldValue("quantity", quantity + 1)
      checkAmountValidation(quantity + 1)
    } else setQuantityError(true)
  }

  const decrementCounter = () => {
    if (quantity > 1) {
      checkAmountValidation(quantity - 1)
      setQuantity(quantity - 1)
      formikProps.setFieldValue("quantity", quantity - 1)
    }
    if (quantityError) setQuantityError(false)
  }

  return (
    <StyledWrapper>
      <StyledText>כמות כרטיסי גיפטקארד</StyledText>
      <StyledBoxWrapper>
        <Box display={"flex"}>
          <StyledButton
            onClick={incrementCounter}
            aria-label="הוספת יחידה ברכישת גיפטקארד"
          >
            +
          </StyledButton>
          <StyledValueBox $quantity={quantity}>
            <FormInput
              name="quantity"
              label=""
              type="text"
              disabled={true}
              value={quantity}
            />
          </StyledValueBox>
          <StyledButton
            onClick={decrementCounter}
            aria-label="הסרת יחידה מהזמנת הגיפטקארד"
          >
            -
          </StyledButton>
        </Box>
        {quantityError && (
          <StyledError>ניתן לרכוש עד {maxGiftCard} גיפטקארדים</StyledError>
        )}
      </StyledBoxWrapper>
    </StyledWrapper>
  )
}

export default QuantityBox
